import { useBaseMetadataForLinkedEntities, useModuleFederationContext } from '@msdk/common'
import { FormFieldDefinition, StringFieldDefinition } from '@msdk/definitions'
import { Box, styled, Tooltip } from '@msdk/ui'
import React from 'react'

import { CustomFieldProps, FieldProps } from '../../models/form'
import { resolveConfig, resolveItem } from '../../utils'
import { ImportedComponentErrorBoundary } from '../ImportedComponentBoundary'

const MissingComponent = styled('div')`
  width: 100%;
  height: 40px;
  background-color: red;
  color: white;
  text-align: center;
  border-radius: 5px;
  padding: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export function CustomField({ node, onChange, fieldArgs }: FieldProps) {
  const formField = node.value.formDefinition as FormFieldDefinition
  const fieldDef = node.value.fieldDefinition as StringFieldDefinition

  /**
   * using the module search instead of the form search because filters also can have custom fields
   * in that case a fake formField is created and instead of having the formName the prop contains the
   * view name where the filter id. Using useMdouleBaseMetadata ensures that the correct metadata
   * is used for both the form fields and the filters.
   */
  const baseMetadata = useBaseMetadataForLinkedEntities(fieldDef.entityName, formField.formName)

  const modules = useModuleFederationContext()
  const msModule = baseMetadata ? modules.loadedModules[baseMetadata.msProvider] : undefined
  const ImportedComponent = msModule ? resolveItem(msModule, formField.customUI) : undefined
  const config = resolveConfig(formField.config)

  const componentProps: CustomFieldProps = {
    node,
    onChange,
    fieldArgs,
    config,
  }

  return (
    <Box className="custom-field">
      {ImportedComponent && (
        <ImportedComponentErrorBoundary>
          <ImportedComponent {...componentProps} />
        </ImportedComponentErrorBoundary>
      )}
      {!ImportedComponent && (
        <Tooltip title={formField.customUI}>
          <MissingComponent>{formField.customUI}</MissingComponent>
        </Tooltip>
      )}
    </Box>
  )
}
